import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const splitViewDefaultVariants = {}
const splitViewCompoundVariants = []

const splitViewSlotNames = [
  [
    "root",
    "splitView__root"
  ],
  [
    "panel",
    "splitView__panel"
  ],
  [
    "dropZoneContainer",
    "splitView__dropZoneContainer"
  ],
  [
    "dropZone",
    "splitView__dropZone"
  ],
  [
    "dragSource",
    "splitView__dragSource"
  ]
]
const splitViewSlotFns = /* @__PURE__ */ splitViewSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, splitViewDefaultVariants, getSlotCompoundVariant(splitViewCompoundVariants, slotName))])

const splitViewFn = memo((props = {}) => {
  return Object.fromEntries(splitViewSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const splitViewVariantKeys = []
const getVariantProps = (variants) => ({ ...splitViewDefaultVariants, ...compact(variants) })

export const splitView = /* @__PURE__ */ Object.assign(splitViewFn, {
  __recipe__: false,
  __name__: 'splitView',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: splitViewVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, splitViewVariantKeys)
  },
  getVariantProps
})